import { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import Modal from "./Modal";
import styles from "../../../styles/aprt.module.scss";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

const PdfModal = ({ isOpen, onClose, pdfUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
    updateScale();
  };

  const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () =>
    setPageNumber((prev) => Math.min(prev + 1, numPages));

  const updateScale = () => {
    const defaultWidth = 1191; // ? Default width of the PDF page at scale 1 ?
    const defaultHeight = 842; // ? Default height of the PDF page at scale 1 ?
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const scaleX = (windowWidth * 0.9) / defaultWidth;
    const scaleY = (windowHeight * 0.75) / defaultHeight;
    const newScale = Math.min(scaleX, scaleY);
    setScale(newScale);
  };

  useEffect(() => {
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className={styles.pdf_modal}>
       <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess} > 
          <Page 
          pageNumber={pageNumber} 
          scale={scale} 
          />
        </Document>
        {numPages > 1 && (
          <div className={styles.pdf_modal_controls}>
            <button
              onClick={goToPrevPage}
              disabled={pageNumber === 1}
              className={styles.modal_button}
            >
              {`<`}
            </button>
            <span>
              {pageNumber} / {numPages}
            </span>
            <button
              onClick={goToNextPage}
              disabled={pageNumber === numPages}
              className={styles.modal_button}
            >
              {`>`}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PdfModal;
